// AcceptServiceOrderReqWithDiscAdmPage.js
import React, { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import "../../../invite.css";

const AcceptServiceOrderReqWithDiscAdmPage = () => {
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const mainId = new URLSearchParams(window.location.search).get("pvid");

    const handleAccept = async () => {
      if (!mainId) {
        console.warn("❌ Missing pvid in query string");
        setSuccess(false);
        setErrorMsg("Missing Work Order Request ID.");
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `${BASE_URL}/WorkOrderRequest/Response_Discount_WorkOrderRequest_ByAdmin`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              workOrderRequestID: parseInt(mainId),
              approveByID: 18, // ⚡ maybe later replace with logged-in admin ID
              statusID: 1, // 1 = Accept
            }),
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(`Approval failed with status ${response.status}`);
        }

        if (data.isSuccess) {
          setSuccess(true);
        } else {
          setSuccess(false);
          setErrorMsg(data.message || "Approval failed.");
        }
      } catch (err) {
        console.error("❌ Error in handleAccept:", err);
        setSuccess(false);
        setErrorMsg(err.message || "Unexpected error.");
      } finally {
        setLoading(false);
      }
    };

    handleAccept();
  }, [BASE_URL]);

  if (loading) {
    return (
      <div className="center-screen">
        <div className="loader-container" aria-live="polite">
          <img
            src="/Montdor_1.png"
            alt="Company Logo"
            className="company-logo"
            onError={(e) => (e.target.style.display = "none")}
          />
          <div className="spinner"></div>
          <p className="loader-text">Processing your request...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="center-screen" style={{ backgroundColor: "#2c2139" }}>
      <div className="card-box">
        {success ? (
          <>
            <div className="icon">
              <FaCheck size={48} color="#a0b750" />
            </div>
            <h2 className="card-title">Approved</h2>
            <p className="card-msg">Additional Item has been Approved.</p>
          </>
        ) : (
          <>
            <div className="icon">
              <FaCheck size={48} color="#888" />
            </div>
            <h2 className="card-title">Error</h2>
            <p className="card-msg">
              {errorMsg || "Unable to approve Additional Item."}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default AcceptServiceOrderReqWithDiscAdmPage;
